"use client"
import React from "react";

const ServiceLinkContent = ({ content }) => {
  return (
    <div className="service-link-content">
      {content.text && (
        <div className="service-link-text">
          <span className="medium">
            <strong>{content.text}</strong>
          </span>
        </div>
      )}
      <div
        className="default-flex-column-layout links"
        style={{ marginTop: "0.75rem" }}
      >
        {content.url && (
          <div>
            <a
              className="with-icon"
              href={content.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-solid fa-globe"></i>
              <span>View Webpage</span>
            </a>
          </div>
        )}
        {content.emailAddress && (
          <div>
            <a className="with-icon" href={"mailto:" + content.emailAddress}>
              <i className="fa-solid fa-envelope"></i>
              <span>Email Us</span>
            </a>
          </div>
        )}
        {content.phoneNumber && (
          <div>
            <a className="with-icon" href={"tel:" + content.phoneNumber}>
              <i className="fa-solid fa-phone"></i>
              <span>Call Us</span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceLinkContent;
